module.exports = __webpack_public_path__ + "img/my_class_icon.c411cf15.svg";